import { useEffect, useRef } from 'react';

type EnhancedErrorLike = {
  originalError?: unknown;
  userFriendlyMessage?: string;
} | null | undefined;

export const useErrorToastOnce = (
  enhancedError: EnhancedErrorLike,
  onShow: (originalError: unknown, message?: string) => void
) => {
  const lastKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enhancedError) return;

    const message = enhancedError.userFriendlyMessage || '';
    const orig = (enhancedError as any)?.originalError;
    const origMsg = typeof orig === 'object' && orig ? (orig as any).message || '' : String(orig ?? '');
    const key = `${origMsg}::${message}`;

    if (lastKeyRef.current !== key) {
      lastKeyRef.current = key;
      onShow(orig, message);
    }
  }, [enhancedError, onShow]);
};


